var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import request from 'superagent';
import WmsLayer from '../layers/WmsLayer';
import LayerGroup from './LayerGroup';
import LayerSwitch from './LayerSwitch';

/**
 * Layer manager configured from an Adaptive Gui.
 */

var AdaptiveLayerManager = (_temp = _class = function (_React$Component) {
  _inherits(AdaptiveLayerManager, _React$Component);

  function AdaptiveLayerManager(props) {
    _classCallCheck(this, AdaptiveLayerManager);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      config: null,
      loading: false
    };
    return _this;
  }

  AdaptiveLayerManager.prototype.componentDidMount = function componentDidMount() {
    this.readConfig();
  };

  AdaptiveLayerManager.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        langCode = _props.langCode,
        guiUuid = _props.guiUuid,
        a3Url = _props.a3Url;


    if (prevProps.langCode != langCode || prevProps.guiUuid != guiUuid || prevProps.a3Url != a3Url) {
      this.readConfig();
      return;
    }
  };

  AdaptiveLayerManager.prototype.readConfig = function readConfig() {
    var _this2 = this;

    var _props2 = this.props,
        langCode = _props2.langCode,
        guiUuid = _props2.guiUuid,
        a3Url = _props2.a3Url,
        onError = _props2.onError,
        gmSessionId = _props2.gmSessionId;

    this.setState({ loading: true });
    request.get(a3Url + 'api/Gui/' + guiUuid + '/LayerManagerConfig/').set('gm_lang_code', langCode).set('gm_session_id', gmSessionId).then(function (res) {
      var config = res.body;
      var configAsTree = _this2.configToTree(config);
      var baseLayersIdx = configAsTree.findIndex(function (group) {
        return group.name === 'baseLayers';
      });
      var guiName = config.find(function (element) {
        return !element.parents;
      }).name;

      if (baseLayersIdx != -1 && configAsTree[baseLayersIdx].children && configAsTree[baseLayersIdx].children.length > 0) configAsTree[baseLayersIdx].enabledLayers = [configAsTree[baseLayersIdx].children[0].id];

      _this2.setState({
        config: configAsTree,
        guiName: guiName,
        loading: false
      });
    }).catch(function (err) {
      onError && onError(err);
      _this2.setState({ loading: false });
    });
  };

  AdaptiveLayerManager.prototype.configToTree = function configToTree(config) {
    var getChildConfig = function getChildConfig(parentId) {
      parentId = parentId || config && config.find(function (element) {
        return !element.parents;
      }).id;
      var children = config.filter(function (element) {
        return element.parents && element.parents[parentId];
      }).sort(function (a, b) {
        return a.parents[parentId] - b.parents[parentId];
      });

      return children.map(function (child) {
        switch (child.type) {
          case 'WMS':
            return child;
          case 'group':
            child.children = getChildConfig(child.id);
            return child;
        }
      }).filter(function (child) {
        return !!child;
      });
    };

    return getChildConfig();
  };

  AdaptiveLayerManager.prototype.getChildren = function getChildren(children) {
    var _this3 = this;

    var lang = this.props.lang;


    return children.map(function (element) {
      switch (element.type) {
        case 'WMS':
          return React.createElement(WmsLayer, {
            id: element.id,
            key: element.id,
            name: element.name,
            uri: element.uri,
            layerName: element.layerName,
            version: element.version,
            useBaat: element.useBaat,
            singleTile: element.singleTile,
            wmsLayerParams: element.wmsLayerParams,
            zIndex: element.zIndex
          });
        case 'group':
          return React.createElement(
            LayerGroup,
            {
              id: element.id,
              key: element.id,
              type: element.type,
              name: element.name === 'baseLayers' ? lang.baselayerCategoryTitle : element.name,
              enabledLayers: element.enabledLayers || [],
              singleSelect: element.singleSelect
            },
            _this3.getChildren(element.children)
          );
      }
    }).filter(function (child) {
      return !!child;
    });
  };

  AdaptiveLayerManager.prototype.render = function render() {
    var _state = this.state,
        config = _state.config,
        loading = _state.loading,
        guiName = _state.guiName;
    var loadingComponent = this.props.loadingComponent;

    return React.createElement(
      'div',
      null,
      React.createElement(
        LayerSwitch,
        { name: guiName },
        loading && loadingComponent,
        !loading && config && this.getChildren(config)
      )
    );
  };

  return AdaptiveLayerManager;
}(React.Component), _class.defaultProps = {
  langCode: 'en',
  lang: { baselayerCategoryTitle: 'Baselayers' }
}, _temp);
AdaptiveLayerManager.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Session id to authenticate Adaptive user
   */
  gmSessionId: PropTypes.string,
  /**
   * Lang code used in request to Adaptive
   */
  langCode: PropTypes.string,
  /**
   * Adaptive url
   */
  a3Url: PropTypes.string.isRequired,
  /**
   * Adaptive gui uuid
   */
  guiUuid: PropTypes.string.isRequired,
  /**
   * Override default lang
   */
  lang: PropTypes.object,
  /**
   * Component to be rendered when config is loading
   */
  loadingComponent: PropTypes.node,
  /**
   * Callback function. Triggered if any errors occurs when reading from Adaptive
   */
  onError: PropTypes.func
} : {};


export default AdaptiveLayerManager;